import { PageType, State } from "./types";

export const initialState: State = {
  Page: PageType.LOADING,
  loading: true,
};
